import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ChatReplyModel } from '@models/chat-reply.model'
import { ChatService, RequestServices } from '@app/services'
import { notification } from 'onsenui'
import { ChatFileModel } from '@models/chat-file.model'

@Component({
    selector: 'app-chat-reply',
    templateUrl: './chat-reply.component.html',
    styleUrls: ['./chat-reply.component.css'],
})
export class ChatReplyComponent implements OnInit {

    @Input() isPatient = false
    @Input() enableAttach = false

    @Input() maxSize = 256 // MB
    @Input() communicationId: string
    @Output() _onSubmit: EventEmitter<ChatReplyModel> = new EventEmitter<ChatReplyModel>()

    formGroup: FormGroup

    constructor(private formBuilder: FormBuilder, private chatService: ChatService, private requestService: RequestServices) {
    }

    ngOnInit() {
        this.validatorForm()
    }

    sendReply() {
        if (this.formGroup.dirty && this.formGroup.valid) {
            this.chatService.addReply(this.formGroup.controls.content.value, this.isPatient)
            this.formGroup.controls.content.reset('')
        }
    }

    uploadFiles(event) {
        console.debug('start handleFileInput', event)

        const files: FileList = event.target.files
        if (files && files[0]) {
            let idx
            const fileCount = files.length
            for (idx = 0; idx < fileCount; idx++) {
                const file = files[idx]
                if (
                    file &&
                    this.checkMimeType(file) &&
                    this.checkMaxSizeUpload(file)
                ) {
                    const chatFile: ChatFileModel = {
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        handlingUpload: this.requestService.postFile(file),
                    }

                    this.chatService.addFile(chatFile, this.isPatient)
                }
            }
        }
    }

    private validatorForm() {
        this.formGroup = this.formBuilder.group({
            content: ['', Validators.required],
        })
    }

    private checkMimeType(file) {
        return (
            file['type'] === 'image/jpeg' ||
            file['type'] === 'image/png' || file['type'] === 'image/tiff'
        ) || file['type'].search('video/') > -1 || file['type'] === 'application/pdf'
    }

    // 256MB
    private checkMaxSizeUpload(file) {
        console.debug('check file size')
        if (parseInt(file['size']) / 1024 / 1024 > this.maxSize) {
            this.showError('communication-video-max-upload-size-exceeded')
            $('#inputUpload0').val('')
            return false
        } else {
            return true
        }
    }

    private showError(message) {
        notification.confirm({
            message: message,
            title: '<b>Alert</b>',
            cancelable: false,
            buttonLabels: ['OK'],
        })
    }


}



// WEBPACK FOOTER //
// ./src/app/commons/chat/chat-reply/chat-reply.component.ts